import { searchInoviceDocumentDetailService } from 'Api/services/busServices'
import DocumentDetailIvend from 'Components/DocumentDetailIvend'
import { t } from 'i18next'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { ROUTES } from 'Utils/constants'

function RepaymentDetail() {
  const { id } = useParams()

  const [loadingData, setLoadingData] = useState(false)
  const [repaymentDetail, setRepaymentDetail] = useState([])

  const columns = [
    {
      Header: t('DETAIL_DOCUMENTS_T.REFERENCE_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.REFERENCE_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.DESCRIPTION_LABEL'),
      accessor: t('DETAIL_DOCUMENTS_T.DESCRIPTION_ACCESOR'),
      width: '40%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.QTY_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.QTY_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.UNITY_PRICE_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.UNITY_PRICE_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.DISCOUNT_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.DISCOUNT_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.PRECIO_TOTAL_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.PRECIO_TOTAL_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
  ]

  const combinedArray = [
    repaymentDetail?.RelationalDocs?.Quote && {
      Type: 'quote',
      Name: 'Cotización',
      DocumentTypeId: repaymentDetail.RelationalDocs.Quote.QuoteHeaderId,
      Path: ROUTES.editQuoteHeaderId,
      ...repaymentDetail.RelationalDocs.Quote,
    },
    ...(Array.isArray(repaymentDetail?.RelationalDocs?.SalesOrders)
      ? repaymentDetail.RelationalDocs.SalesOrders.map(order => ({
          Type: 'salesOrder',
          Name: 'Orden de venta',
          DocumentTypeId: order?.SaleOrderHeaderId,
          Path: ROUTES.salesOrder,
          ...order,
        }))
      : []),
    ...(Array.isArray(repaymentDetail?.RelationalDocs?.RequestDispatchs) &&
    repaymentDetail.RelationalDocs.RequestDispatchs.length > 0
      ? repaymentDetail.RelationalDocs.RequestDispatchs.map(dispatch => ({
          Type: 'requestDispatch',
          Name: 'Despacho',
          DocumentTypeId: dispatch?.RequestDispatchHeaderId,
          Path: ROUTES.orderDispatch,
          ...dispatch,
        }))
      : []),
    repaymentDetail?.RelationalDocs?.ElectronicInvoice && {
      Type: 'electronicInvoice',
      Name: 'Factura electrónica',
      DocumentTypeId:
        repaymentDetail.RelationalDocs.ElectronicInvoice.ElectronicInvoiceId,
      ...repaymentDetail.RelationalDocs.ElectronicInvoice,
    },
    ...(Array.isArray(repaymentDetail?.RelationalDocs?.PurchaseOrders)
      ? repaymentDetail.RelationalDocs.PurchaseOrders.map(purchaseOrder => ({
          Type: 'purchaseOrders',
          Name: 'Orden de compra',
          ...purchaseOrder,
        }))
      : []),
  ].filter(Boolean)

  const fetchDocument = async (docId = null) => {
    setLoadingData(true)
    try {
      const { Data } = await searchInoviceDocumentDetailService(docId)

      const isValidDataService = Data && Object.keys(Data).length > 0

      if (isValidDataService) {
        setRepaymentDetail(Data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingData(false)
    }
  }
  useEffect(() => {
    fetchDocument(id)
  }, [id])

  return DocumentDetailIvend({
    loadingData,
    data: repaymentDetail,
    combinedArray,
    columns,
    title: 'DETAIL_DOCUMENTS_T.REPAYMENT_TITLE',
  })
}

export default RepaymentDetail
